import { useState } from "nuxt/app";
export function useAvailableShops() {
  return useState("availableShops", () => []);
}
